import * as RMenu from "@radix-ui/react-dropdown-menu";
import type { ReactNode } from "react";

export interface DropdownMenuProps {
  trigger: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  align?: "start" | "center" | "end";
  side?: "top" | "right" | "bottom" | "left";
}

export function DropdownMenu({
  trigger,
  children,
  contentClassName,
  align = "end",
  side = "bottom",
}: DropdownMenuProps): JSX.Element {
  return (
    <RMenu.Root>
      <RMenu.Trigger asChild>{trigger}</RMenu.Trigger>
      <RMenu.Portal>
        <RMenu.Content
          className={contentClassName ?? "ds-menu__content"}
          align={align}
          side={side}
          sideOffset={4}
        >
          {children}
        </RMenu.Content>
      </RMenu.Portal>
    </RMenu.Root>
  );
}

export interface DropdownMenuItemProps {
  children: ReactNode;
  onSelect?: (event: Event) => void;
  disabled?: boolean;
  className?: string;
}

export function DropdownMenuItem({
  children,
  onSelect,
  disabled,
  className,
}: DropdownMenuItemProps): JSX.Element {
  return (
    <RMenu.Item
      className={className ?? "ds-menu__item"}
      onSelect={onSelect}
      disabled={disabled}
    >
      {children}
    </RMenu.Item>
  );
}

export const DropdownMenuSeparator = RMenu.Separator;
export const DropdownMenuLabel = RMenu.Label;
